<template>
  <div class="zmzh-block">
    <component
      :chip="chip"
      class="hori-list"
      v-for="(d, i) in data.horizontal"
      :is="componentName(i)"
      :key="'h' + i"
      :horizontal-type="2"
      :title="d.title"
      :columns="i !== 1 ? 4 : 3"
      :list="d.list" />
  </div>
</template>

<script>
  import mixin from '../mixins';
  import GSwitchList1 from '../../c_game-switch/switch-list/g_switch-1'; // 横向
  import GSwitchList3 from '../../c_game-switch/switch-list/g_switch-3'; // 横向
  export default {
    name: "gd_ha10-zmzh",
    mixins: [mixin],
    components: {
      GSwitchList1,
      GSwitchList3
    },
    methods: {
      componentName(index) {
        return index !== 1 ? 'g-switch-list1' : 'g-switch-list3';
      }
    }
  }
</script>

<style scoped lang="stylus">
  .hori-list + .hori-list {
    margin-top 7px
  }
</style>



// WEBPACK FOOTER //
// src/components/pageComponents/gd_ha10/zmzh.vue